import { DEFAULT_VIDEO_CREATION_ERROR, ERROR_KINDS, ERROR_TEXT_BY_KIND, ProjectFailedFriendlyToast } from './constants';

export const getErrorTextByKind = (errorKind?: string): string => {
    const errorKindsAsStringArray: string[] = Object.values(ERROR_KINDS) as string[];
    if (!errorKind || !errorKindsAsStringArray.includes(errorKind)) {
        return DEFAULT_VIDEO_CREATION_ERROR;
    }

    const validErrorKind = errorKind as ERROR_KINDS;

    return ERROR_TEXT_BY_KIND[validErrorKind];
};

export const getFriendlyToastError = (projectFailedErrorToFriendlyToastJson: Record<string, ProjectFailedFriendlyToast>, kind?: string) => {
    return (
        (kind && projectFailedErrorToFriendlyToastJson[kind]) ||
        projectFailedErrorToFriendlyToastJson['DefaultError'] || { title: 'Failed to generate your video', message: 'Please try again' }
    );
};
